import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import actions from 'actions';
import NewPage from 'components/content/page/new';
import { slugify } from 'utils';
import { confirmRouteLeave, confirmPageLeave } from 'utils/container';

export const mapStateToProps = (state) => ({
  data: state.data,
  loading: state.data.loading,
  errors: state.data.recordErrors,
  content: state.content,
  storefronts: state.storefronts,
});

export const mapDispatchToProps = (dispatch) => ({
  createRecord: (data) => {
    return dispatch(actions.data.createRecord('content/pages', data));
  },
});

export class NewContentPage extends React.Component {
  static contextTypes = {
    notifyCreated: PropTypes.func.isRequired,
    notifyError: PropTypes.func.isRequired,
    openModal: PropTypes.func.isRequired,
    client: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      values: {},
      edited: false,
      onChangeForm: this.onChangeForm.bind(this),
      onSubmitRecord: this.onSubmitRecord.bind(this),
    };
  }

  componentDidMount() {
    confirmRouteLeave(this);
  }

  componentDidUpdate(_prevProps, prevState) {
    confirmPageLeave(this, prevState);
  }

  componentWillUnmount() {
    confirmPageLeave(this);
  }

  onChangeForm(values, edited) {
    this.setState({
      values: {
        ...this.state.values,
        ...values,
      },
      edited,
    });
  }

  async onSubmitRecord(values) {
    const { router, createRecord } = this.props;

    const result = await createRecord({
      ...values,
      slug: values.slug || slugify(values.title),
    });

    if (result.errors) {
      this.context.notifyError(result.errors);
    } else {
      this.setState({
        edited: false,
      });
      router.replace(`/content/pages/${result.id}`);
      this.context.notifyCreated(result);
    }
  }

  render() {
    return <NewPage {...this.props} {...this.state} />;
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(NewContentPage);
